module.exports = __webpack_public_path__ + "img/skateboarding.f21c12aa.svg";